import { useEffect } from 'react'

import { SuggestSlippageRequest, useGetSuggestedSlippage } from '@/data/optimex'
import { useSlippageStore } from '@/store/slippage'

export const useSlippageSettings = ({
  isFixedSwap = false,
  isBridge = false,
}: {
  isFixedSwap: boolean
  isBridge: boolean
}) => {
  const { maxSlippage, slippageBridge, ...store } = useSlippageStore()

  const setSlippage = isFixedSwap ? store.setSlippageFixedRate : store.setSlippage

  const isCustomSlippage = isFixedSwap ? store.isCustomSlippageFixedRate : store.isCustomSlippage

  const suggestSlippage = isBridge ? slippageBridge : store.suggestSlippage

  const slippage = !isCustomSlippage ? suggestSlippage : isFixedSwap ? store.slippageFixedRate : store.slippage

  return {
    maxSlippage,
    slippage, // current slippage
    setSlippage,
    suggestSlippage, // suggested(auto) slippage
    isCustomSlippage,
    setIsCustomSlippage: isFixedSwap ? store.setIsCustomSlippageFixedRate : store.setIsCustomSlippage,
  }
}

export const useFetchSlippage = (debouncedParams: SuggestSlippageRequest) => {
  const { data } = useGetSuggestedSlippage(debouncedParams)
  const { setSuggestSlippage } = useSlippageStore()

  // auto update suggested slippage
  useEffect(() => {
    const { autoSlippage, maxSlippage, autoSlippageBridge } = data ?? {}
    setSuggestSlippage({ autoSlippage, maxSlippage, autoSlippageBridge })
  }, [data, setSuggestSlippage])
}
